import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function BackButton({ to, onClick, label = "Back", testId = "back-button" }) {
  const navigate = useNavigate();
  const handle = () => {
    if (onClick) return onClick();
    if (to) return navigate(to);
    if (window.history.length > 1) return navigate(-1);
    navigate("/");
  };
  return (
    <button
      onClick={handle}
      className="inline-flex items-center gap-1.5 h-9 pl-2.5 pr-4 rounded-full border border-slate-200 bg-white text-xs font-bold text-navy hover:border-gold hover:bg-cream transition-colors"
      data-testid={testId}
    >
      <ArrowLeft size={14} /> {label}
    </button>
  );
}
